import { Component, Input } from '@angular/core';

@Component({
  selector: 'my-password-strength',
  template: `
   <div class="score" style="display: block;"><span><b class="fill" [style.width]="width" [style.background-color]="color"></b></span></div>
  `,
  styles: [`
  .score .fill {
    display: block;
    height: 8px;
    width: 25px;
    background-color: #6ec02a;
    transition: width .6s ease-in .1s;
  }
  .score {
    display: none;
    position: absolute;
    top: 3px;
    right: 35px;
  } 
  .score span {
    width: 50px;
    height: 8px;
    display: inline-block;
    overflow: hidden;
    background-color: #e6ecf0;
    vertical-align: middle;
    border-radius: 3px;
  }
  `]
})
export class PasswordStrengthComponent {

  @Input()
  width: string;

  @Input()
  color: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/components/password.strength/password.strength.component.ts